module.exports = __webpack_public_path__ + "img/ai-img-p3.f6a08e22.png";